/*
*验证模块 使用正则表达式 或其它验证方式 用户可自行拓展
*
*/

/**
 * 手机号码验证
 * @param mobile
 * @returns {*}
 */
export function verifyMobile(mobile) {
  // 允许空值，若需必填请添加多验证规则
  if (!mobile) {
    return false;
  }
  if (!/^(1[3-9])\d{9}$/.test(mobile.toString())) {
    return false;
  }
  return true;
}

/**
 * 密码 正则验证
 * @param value
 */
export function verifyPassword(value){
  //密码由字母或数字开头，且只能为字母,数字,下划线及（.）长度在 6 到 18 个字符
  const reg = /^[A-Za-z0-9][A-Za-z0-9_.]{5,17}$/
  if (!value.match(reg)) {
    return false;
  } else {
    return true;
  }
}

/**
 * 手机号码验证
 * @param rule
 * @param mobile
 * @param callback
 * @returns {*}
 */
export function validatorMobile(rule, mobile, callback) {
  // 允许空值，若需必填请添加多验证规则
  if (!mobile) {
    return callback()
  }
  if (!/^(1[3-9])\d{9}$/.test(mobile.toString())) {
    return callback(new Error("手机号格式不正确！"))
  }
  return callback()
}

export const mobileRule = { validator: validatorMobile, trigger: 'blur' }

/**
 * 密码 正则验证
 * @param rule
 * @param value
 * @param callback
 */
export function validatorPassword(rule, value, callback){
  //密码只能由大小写英文字母或数字开头，且由大小写英文字母_.组成
  const reg = /^[A-Za-z0-9][A-Za-z0-9_.]{5,17}$/
  if (!value.match(reg)) {
    callback(new Error('密码由字母或数字开头，且只能为字母,数字,下划线及（.）长度在 6 到 18 个字符'))
  } else {
    callback()
  }
}

/**
 * 邮箱验证
 * @param email
 * @returns {Boolean}
 */
export function verifyEmail(email) {
  if (!email) {
    return false
  }
  const reg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
  return reg.test(email)
}

/**
 * 邮箱验证器（用于Element Plus表单）
 * @param rule
 * @param email
 * @param callback
 */
export function validatorEmail(rule, email, callback) {
  if (!email) {
    return callback()
  }
  if (!verifyEmail(email)) {
    return callback(new Error('邮箱格式不正确！'))
  }
  return callback()
}

/**
 * 验证码验证（6位数字）
 * @param code
 * @returns {Boolean}
 */
export function verifyCode(code) {
  if (!code) {
    return false
  }
  return /^\d{6}$/.test(code.toString())
}

/**
 * 验证码验证器（用于Element Plus表单）
 * @param rule
 * @param code
 * @param callback
 */
export function validatorCode(rule, code, callback) {
  if (!code) {
    return callback(new Error('请输入验证码'))
  }
  if (!verifyCode(code)) {
    return callback(new Error('验证码为6位数字'))
  }
  return callback()
}

/**
 * 文件大小验证
 * @param file - 文件对象
 * @param maxSize - 最大大小（MB）
 * @returns {Object} { valid: Boolean, message: String }
 */
export function validateFileSize(file, maxSize = 10) {
  const isLtMaxSize = file.size / 1024 / 1024 < maxSize
  if (!isLtMaxSize) {
    return { valid: false, message: `文件大小不能超过${maxSize}MB` }
  }
  return { valid: true }
}

/**
 * 文件类型验证
 * @param file - 文件对象
 * @param allowedTypes - 允许的文件类型数组
 * @returns {Object} { valid: Boolean, message: String }
 */
export function validateFileType(file, allowedTypes = []) {
  if (!allowedTypes.includes(file.type)) {
    return { valid: false, message: '不支持的文件类型' }
  }
  return { valid: true }
}

/**
 * 文件验证（综合验证大小和类型）
 * @param file - 文件对象
 * @param options - 配置选项 { maxSize, allowedTypes }
 * @returns {Object} { valid: Boolean, message: String }
 */
export function validateFile(file, options = {}) {
  const { 
    maxSize = 10, 
    allowedTypes = ['image/jpeg', 'image/png', 'image/jpg', 'video/mp4', 'audio/mp3']
  } = options
  
  // 检查文件大小
  const sizeResult = validateFileSize(file, maxSize)
  if (!sizeResult.valid) {
    return sizeResult
  }
  
  // 检查文件类型
  const typeResult = validateFileType(file, allowedTypes)
  if (!typeResult.valid) {
    return typeResult
  }
  
  return { valid: true }
}

/**
 * 图片文件验证
 * @param file - 文件对象
 * @param maxSize - 最大大小（MB），默认5MB
 * @returns {Object} { valid: Boolean, message: String }
 */
export function validateImageFile(file, maxSize = 5) {
  const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png']
  return validateFile(file, { maxSize, allowedTypes })
}

/**
 * 必填字段验证规则（用于Element Plus表单）
 * @param message - 错误提示信息
 * @param trigger - 触发方式，默认'blur'
 * @returns {Object}
 */
export function requiredRule(message = '此字段为必填项', trigger = 'blur') {
  return { required: true, message, trigger }
}

/**
 * 手机号验证规则（用于Element Plus表单）
 * @returns {Array}
 */
export function mobileRules() {
  return [
    { required: true, message: '请输入手机号', trigger: 'blur' },
    { validator: validatorMobile, trigger: 'blur' }
  ]
}

/**
 * 邮箱验证规则（用于Element Plus表单）
 * @returns {Array}
 */
export function emailRules() {
  return [
    { required: true, message: '请输入邮箱', trigger: 'blur' },
    { validator: validatorEmail, trigger: 'blur' }
  ]
}

/**
 * 验证码验证规则（用于Element Plus表单）
 * @returns {Array}
 */
export function codeRules() {
  return [
    { required: true, message: '请输入验证码', trigger: 'blur' },
    { validator: validatorCode, trigger: 'blur' }
  ]
}

/**
 * 密码验证规则（用于Element Plus表单）
 * @returns {Array}
 */
export function passwordRules() {
  return [
    { required: true, message: '请输入密码', trigger: 'blur' },
    { validator: validatorPassword, trigger: 'blur' }
  ]
}

/**
 * 长度验证规则（用于Element Plus表单）
 * @param min - 最小长度
 * @param max - 最大长度
 * @param message - 错误提示信息
 * @returns {Object}
 */
export function lengthRule(min, max, message) {
  return { 
    min, 
    max, 
    message: message || `长度在${min}-${max}个字符`, 
    trigger: 'blur' 
  }
}

/**
 * 姓名验证规则（用于Element Plus表单）
 * @returns {Array}
 */
export function nameRules() {
  return [
    { required: true, message: '请输入姓名', trigger: 'blur' },
    { min: 2, max: 20, message: '姓名长度在2-20个字符', trigger: 'blur' }
  ]
}

/**
 * 职称验证规则（用于Element Plus表单）
 * @returns {Array}
 */
export function titleRules() {
  return [
    { required: true, message: '请输入职称', trigger: 'blur' },
    { max: 50, message: '职称不能超过50个字符', trigger: 'blur' }
  ]
}

/**
 * 个人简介验证规则（用于Element Plus表单）
 * @returns {Array}
 */
export function introductionRules() {
  return [
    { required: true, message: '请输入个人简介', trigger: 'blur' },
    { min: 10, max: 500, message: '个人简介长度在10-500个字符', trigger: 'blur' }
  ]
}

/**
 * 投诉标题验证规则（用于Element Plus表单）
 * @returns {Array}
 */
export function complaintTitleRules() {
  return [
    { required: true, message: '请输入投诉标题', trigger: 'blur' },
    { min: 5, max: 100, message: '标题长度在5-100个字符', trigger: 'blur' }
  ]
}

/**
 * 投诉描述验证规则（用于Element Plus表单）
 * @returns {Array}
 */
export function complaintDescriptionRules() {
  return [
    { required: true, message: '请输入投诉描述', trigger: 'blur' },
    { min: 20, max: 2000, message: '描述长度在20-2000个字符', trigger: 'blur' }
  ]
}
